import { Component, Input } from '@angular/core';
import { Topic } from '../../../../models/ai-model';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
  selector: 'app-interview-ai-ai-topic',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './interview-ai-ai-topic.component.html',
  styleUrl: './interview-ai-ai-topic.component.scss',
})
export class InterviewAiAiTopicComponent {
  @Input() topicsForWordclouds: Topic[] = [];
  @Input() isLoading: boolean = false;
}
